import React from "react";
import "./Navbar.css"; // Import the CSS file for styling

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg bg-white shadow-sm">
      <div className="container-fluid">
        {/* Logo Section */}
        <a className="navbar-brand" href="/">
          <img src="/satiwtxt.png" alt="Logo" height="70" />
        </a>

        {/* Mobile Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarTogglerDemo02"
          aria-controls="navbarTogglerDemo02"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar Links */}
        <div
          className="collapse navbar-collapse justify-content-center"
          id="navbarTogglerDemo02"
        >
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 ">
            <li className="nav-item">
              <a
                className="nav-link active nav-hover"
                aria-current="page"
                href="/"
              >
                Home
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link active nav-hover"
                aria-current="page"
                href="#about"
              >
                About
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link active nav-hover"
                aria-current="page"
                href="#founder"
              >
                Founder
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link active nav-hover"
                aria-current="page"
                href="#products"
              >
                Products
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link active nav-hover"
                aria-current="page"
                href="#vision"
              >
                Our Vision
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link active nav-hover"
                aria-current="page"
                href="#operations"
              >
                Operations
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link active nav-hover"
                aria-current="page"
                href="#testi"
              >
                Our Customers
              </a>
            </li>

            {/* Contact Us Button (Visible only on mobile) */}
            <li className="nav-item d-lg-none">
              <a href="#contactus">
                <button className="btn btn-danger w-100 mt-2">
                  Contact Us
                </button>
              </a>
            </li>
          </ul>
        </div>

        {/* Contact Us Button (Visible only on desktop) */}
        <button className="btn btn-danger d-none d-lg-block ms-3">
          Contact Us
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
